import React from 'react';
import { Defs, G, LinearGradient, Path, Stop, Svg } from 'react-native-svg';

interface IconProps {
  size?: number;
  fillColor?: string;
  color?: string;
}

export const SolarHomeIcon: React.FC<IconProps> = ({ size = 32 ,color, fillColor}) => {
  const FILL_COLOR = fillColor || '#FDFDFD';
  const colorLine = color || '#7E74E4';

  return(
    <Svg width={size} height={size} viewBox="0 0 32 32" fill="none">
      <Defs>
        <LinearGradient id="paint0_linear_home" x1="26.666" y1="26.667" x2="29.0388" y2="29.5736" gradientUnits="userSpaceOnUse">
          <Stop stopColor={colorLine} />
          <Stop offset="1" stopColor="#443C94" />
        </LinearGradient>

      </Defs>
      <G id="Home">
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.35828 10.4297C2.66602 11.6944 2.66602 13.22 2.66602 16.2712V18.2993C2.66602 23.5005 2.66602 26.1011 4.22811 27.7169C5.79021 29.3327 8.30437 29.3327 13.3327 29.3327H18.666C23.6943 29.3327 26.2085 29.3327 27.7706 27.7169C29.3327 26.1011 29.3327 23.5005 29.3327 18.2993V16.2712C29.3327 13.22 29.3327 11.6944 28.6404 10.4297C27.9481 9.16496 26.6834 8.38003 24.154 6.81018L21.4873 5.15517C18.8135 3.49574 17.4766 2.66602 15.9993 2.66602C14.5221 2.66602 13.1852 3.49574 10.5114 5.15518L7.84473 6.81018C5.31528 8.38003 4.05055 9.16496 3.35828 10.4297ZM12.5948 20.5293C12.1511 20.2004 11.5249 20.2935 11.196 20.7372C10.8671 21.1809 10.9602 21.8072 11.4039 22.136C12.7004 23.0971 14.2861 23.666 15.9993 23.666C17.7126 23.666 19.2983 23.0971 20.5948 22.136C21.0385 21.8072 21.1316 21.1809 20.8027 20.7372C20.4738 20.2935 19.8476 20.2004 19.4039 20.5293C18.4327 21.2491 17.2605 21.666 15.9993 21.666C14.7381 21.666 13.566 21.2491 12.5948 20.5293Z"
          fill={FILL_COLOR}
          stroke="url(#paint0_linear_home)"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </G>
    </Svg>);
};
